import { FormattedMessage } from 'react-intl';
import { Link, List } from '@printdeal/ui-library';
import React from 'react';
import { dispatchDataLayerEntry } from '../../../helpers/dataLayerHelpers/productDataLayerHelper';

interface Props {
  articles: {
    title: string;
    slug: string;
  }[];
}

export const RelatedSupportArticles = ({ articles }: Props) => (
  <>
    <p className="pd-text-dim-500">
      <FormattedMessage id="guided.selling.modal.chat.related" defaultMessage="Related articles:" />
    </p>
    <List variant="icon">
      {articles.map((article) => (
        <List.Item key={article.slug}>
          <Link
            href={article.slug}
            onClick={() => {
              dispatchDataLayerEntry(
                'click_on_related_support_article',
                'click',
                {
                  experiment: 'EXP1530',
                  slug: article.slug,
                  title: article.title,
                },
              );
            }}
            variant="primary"
            className="pd-w-full"
          >
            {article.title}
          </Link>
        </List.Item>
      ))}
    </List>
  </>
);
